import { Outlet } from "react-router-dom";
import { Footer } from "../Footer/Footer";

export const PrintLayout = () => {
	return (
		<div className="w-[100vw] h-[100vh] relative font-urbanist" id="portal-auth">
			<div className="h-[calc(100%)] relative w-full" id="portal-auth">
				<Outlet />
			</div>
		</div>
	);
};
